export default {
  namespace: 'certificates',
  en: {
    title: 'Certificates',
    common: {
      domain: 'Domain name',
      domains: 'Domain names',
      product: 'Product',
      status: 'Status',
      expiresAt: 'Expires at',
      active: 'Active',
      pending: 'Pending',
      expired: 'Expired',
      revoked: 'Revoked',
      approverEmail: 'Approver email',
      certificate: 'Certificate',
      certificateCrt: 'Certificate (CRT)',
      show: 'Show',
      hide: 'Hide',
      copy: 'Copy',
      keyType: 'Key type',
      saveAs: 'Save as {{type}}',
      downloadCertificate: 'Download certificate',
    },
    modals: {
      certificate: {
        download: {
          title: 'Download certificate in PKCS12 format',
          fields: {
            password: {
              title: 'Password',
              validation: 'Please enter a password',
              help: 'A password is required to protect the PKCS12 formatted certificate.',
            },
          },
        },
      },
    },
  },
  nl: {
    title: 'Certificaten',
    common: {
      domain: 'Domeinnaam',
      domains: 'Domeinnamen',
      product: 'Product',
      status: 'Status',
      expiresAt: 'Verloopt op',
      active: 'Actief',
      pending: 'In afwachting',
      expired: 'Verlopen',
      revoked: 'Ingetrokken',
      approverEmail: 'Goedkeurings e-mail',
      certificate: 'Certificaat',
      certificateCrt: 'Certificaat (CRT)',
      show: 'Toon',
      hide: 'Verberg',
      copy: 'Kopieer',
      keyType: 'Sleuteltype',
      saveAs: 'Opslaan als {{type}}',
      downloadCertificate: 'Download certificaat',
    },
    modals: {
      certificate: {
        download: {
          title: 'Certificaat downloaden in PKCS12 formaat',
          fields: {
            password: {
              title: 'Wachtwoord',
              validation: 'Vul een wachtwoord in',
              help: 'Een wachtwoord is verplicht om het PKCS12 certificaat te beveiligen.',
            },
          },
        },
      },
    },
  },
};
